import { useMemo } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'

import { useUserContext } from '~/providers/user-provider'
import { Referal } from './referal'
import { UserProfile } from './user-profile'
import { UsersMgmt } from './users-mgmt'
import { WalletInfos } from './wallet-infos'

export const UserRecap = () => {
	const { isBusiness, userQuery } = useUserContext()

	const user = userQuery.data
	const canManageUsers = user?.permissions?.user_management_write

	const gridColSize = useMemo(() => {
		if (!isBusiness) return 'md:grid-cols-4'

		return canManageUsers ? 'md:grid-cols-3' : 'md:grid-cols-2'
	}, [isBusiness, canManageUsers])

	return (
		<div className={cn('grid items-stretch gap-6', gridColSize)}>
			<UserProfile />

			{!isBusiness && (
				<>
					<WalletInfos />
					<Referal />
				</>
			)}

			<UsersMgmt />
		</div>
	)
}
